import api from './api';
import type { ProductoDto, ProductoCreateRequest, TipoProducto } from '@/types/producto';

export const productosApi = {
  findAll: (tipo?: TipoProducto) =>
    api.get<ProductoDto[]>('/productos', { params: tipo ? { tipo } : {} }).then((r) => r.data),

  findById: (id: number) =>
    api.get<ProductoDto>(`/productos/${id}`).then((r) => r.data),

  create: (data: ProductoCreateRequest) =>
    api.post<ProductoDto>('/productos', data).then((r) => r.data),

  update: (id: number, data: ProductoCreateRequest) =>
    api.put<ProductoDto>(`/productos/${id}`, data).then((r) => r.data),

  uploadImages: (id: number, formData: FormData) =>
    api.post<ProductoDto>(`/productos/${id}/images`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then((r) => r.data),

  delete: (id: number) =>
    api.delete(`/productos/${id}`),
};
